import React from "react";

const FormTextarea = ({ field, value, handleChange, error = null }) => {
  return (
    <div className={field.fieldSize || "col-12"}>
      {field.label !== null ? (
        <label className="form-label text-muted">
          {field.label}{" "}
          {field.required && <span className="text-danger small">*</span>}
        </label>
      ) : (
        <label className="mt-sm-4"></label>
      )}

      <textarea
        className={`form-control ${error ? "border-danger" : ""}`}
        name={field.name}
        value={value || ""}
        onChange={handleChange}
        placeholder={field.placeholder || ""}
        required={field.required || false}
        rows={field.rows || 4}
      />

      {error && <span className="text-danger">{error}</span>}
    </div>
  );
};

export default FormTextarea;
